import { GlobalStateContext } from "GlobalState"
import { Row } from "components/Layout"
import Loader from "components/Loader"
import PageHeader from "components/PageHeader"
import { motion } from "framer-motion"
import _ from "lodash"
import * as gamesAPI from "modules/gamesAPI"
import { useContext, useEffect, useRef, useState } from "react"
import { useAsync, useLocalStorage } from "react-use"
import css from "./Play.module.scss"
import PlayFTUE from "./components/PlayFTUE"
import PlayableContainer from "./components/PlayableContainer"
import PlayableFeedItem from "./components/PlayableFeedItem"

export function PlayPage() {
  const { setShowBottomNavBar } = useContext(GlobalStateContext)
  const [selectedGame, setSelectedGame] = useState(null)
  const [FTUEModalCompleted] = useLocalStorage("playablesFTUEModalCompleted", false)
  const [FTUEScrollCompleted] = useLocalStorage("playablesFTUEScrollCompleted", false)

  const scrollContainerRef = useRef()
  const duration = 0.5

  useEffect(() => {
    setShowBottomNavBar(selectedGame === null)
  }, [selectedGame])

  // Disable browser back gesture while in playable
  useEffect(() => {
    function handlePopState(e) {
      if (selectedGame) {
        window.history.forward()
        setShowBottomNavBar(false)
      }
    }

    window.addEventListener("popstate", handlePopState)

    return () => {
      window.removeEventListener("popstate", handlePopState)
    }
  }, [selectedGame])

  // Load playables Feed API
  const {
    loading,
    error,
    value: playablesList,
  } = useAsync(async () => {
    const playables = await gamesAPI.getPlayablesFeed()

    if(FTUEModalCompleted) {
      let shuffledPlayables = _.shuffle(playables)

      // Requsted from GC - Make sure that ping-pong is somewhere between the 5-7th position
      let pingPongIndex = shuffledPlayables.findIndex(game => game.id === "ping-pong") // find it in the list
      let pingPong = shuffledPlayables.splice(pingPongIndex, 1) // Take it out of the list
      const insertAt = Math.floor(Math.random() * 3) + 5
      shuffledPlayables.splice(insertAt, 0, pingPong[0]) // Insert it at the random position between 5 and 7
      console.log('ping-pong inserted at', insertAt)
      return shuffledPlayables
    }
    return playables
  })

  if (loading) return <Loader />
  if (error) throw error
  if (!playablesList) return <Row align="mc">No Games Found</Row>

  return (
    <>
      <motion.div
        animate={{
          opacity: selectedGame ? 0 : 1,
          top: selectedGame ? "-6rem" : 0, // TODO: page-header height
        }}
        transition={{ duration }}
        className={css.fixedHeader}
      >
        <PageHeader title="Play" settingsMenu background="fullGradient" />
      </motion.div>

      <div className={css.scrollContainer} col={1} ref={scrollContainerRef}>
        {playablesList.map((game, i) => (
          <PlayableFeedItem
            key={i}
            game={game}
            onClick={() => setSelectedGame(game)}
          />
        ))}
      </div>

      <motion.div
        animate={{
          opacity: selectedGame ? 1 : 0,
          pointerEvents: selectedGame ? "auto" : "none",
        }}
        transition={{ duration }}
      >
        <PlayableContainer
          selectedGame={selectedGame}
          setSelectedGame={setSelectedGame}
        />
      </motion.div>

      {(!FTUEModalCompleted || !FTUEScrollCompleted) && (
        <PlayFTUE scrollContainerRef={scrollContainerRef} />
      )}
    </>
  )
}
